import $ from 'jquery';
Object.assign(window, { $, jQuery: $ });
